import type { ApplicationGateApi } from '@tempmee/awards';
import * as Client from '../clients/GetApplicationQuestions';

export const getApplicationQuestionsService = async (
  cycleId: string,
  officeId?: string,
): Promise<ApplicationGateApi> => {
  return Client.getApplicationQuestions(cycleId, officeId);
};
